import script from "./BlockSalary.vue?vue&type=script&setup=true&lang=js"
export * from "./BlockSalary.vue?vue&type=script&setup=true&lang=js"

import "./BlockSalary.vue?vue&type=style&index=0&id=c19fdaaa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c19fdaaa"]])

export default __exports__